/**
 * UiPagePublicView — bare public viewer for a published UI page.
 *
 * Mounted at /p/<slug>. Redirects to the static HTML endpoint at
 * /api/public/ui-page/:slug.html — that endpoint serves a complete HTML
 * document (Tailwind CDN + AI-generated HTML + workflow runtime JS), so
 * there's no React on the public viewer at all.
 */
const React = require('react');
const { createElement: h, useEffect } = React;
const apiClient = require('../lib/apiClient');

function publicHtmlUrl(slug) {
  var base = (apiClient && typeof apiClient.getApiBasePath === 'function')
    ? apiClient.getApiBasePath()
    : '/api';
  return base + '/public/ui-page/' + encodeURIComponent(slug) + '.html';
}

function UiPagePublicView(props) {
  var slug = props.slug;

  useEffect(function() {
    if (!slug) return;
    // Hard navigate so the user lands on the static HTML doc and any reload
    // hits the static endpoint directly.
    window.location.replace(publicHtmlUrl(slug));
  }, [slug]);

  if (!slug) {
    return h('div', {
      style: {
        minHeight: '100vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        background: '#f8fafc', color: '#64748b',
        fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
        padding: '20px', textAlign: 'center'
      }
    },
      h('div', { style: { fontSize: '20px', fontWeight: 600, color: '#0f172a', marginBottom: '8px' } }, 'Page not available'),
      h('div', { style: { fontSize: '14px' } }, 'Missing page slug.')
    );
  }

  return h('div', {
    style: {
      minHeight: '100vh', display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      background: '#f8fafc', color: '#64748b',
      fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif'
    }
  }, 'Loading...');
}

module.exports = UiPagePublicView;
